import type { ScheduledTransaction } from 'app-components/flux/scheduled-transactions/scheduledTransactionsTypes';

import {
  type RecurringTransactionWorkflowParams,
  useRecurringTransactionActions,
} from './useRecurringTransactionActions';
import { useRecurringTransactionEffects } from './useRecurringTransactionEffects';

type RecurringTransactionWorkflow = {
  closeRecurring: (dirty?: boolean, force?: boolean) => void;
  createRecurring: () => void;
  dismissReview: () => void;
  doOneTimeBill: () => void;
  exitRecurringSelect: () => void;
  linkRecurring: (item: ScheduledTransaction) => void;
  markRecurring: () => void;
  onCloseReview: () => void;
  saveRecurring: () => void;
  startRecurringSelect: () => void;
  stopRecurring: () => void;
  updateRecurring: () => void;
};

export function useRecurringTransactionWorkflow(
  params: RecurringTransactionWorkflowParams,
): RecurringTransactionWorkflow {
  const actions = useRecurringTransactionActions(params);

  useRecurringTransactionEffects({
    createRecurring: actions.createRecurring,
    recurring: params.recurring,
    startRecurringSelect: actions.startRecurringSelect,
  });

  return {
    closeRecurring: actions.closeRecurring,
    createRecurring: actions.createRecurring,
    dismissReview: actions.dismissReview,
    doOneTimeBill: actions.doOneTimeBill,
    exitRecurringSelect: actions.exitRecurringSelect,
    linkRecurring: actions.linkRecurring,
    markRecurring: actions.markRecurring,
    onCloseReview: actions.onCloseReview,
    saveRecurring: actions.saveRecurring,
    startRecurringSelect: actions.startRecurringSelect,
    stopRecurring: actions.stopRecurring,
    updateRecurring: actions.updateRecurring,
  };
}

export type { RecurringTransactionWorkflowParams };
